// @ts-expect-error highcharts@7 is not typed

import { TEXT_COLOR, LINE_COLOR_DARK, BATTLESHIP_TRANSPARENT, LINE_COLOR } from './colors';
export const yAxis = {
  lineColor: 'transparent',
  lineWidth: 1,
  gridLineColor: BATTLESHIP_TRANSPARENT,
  gridLineDashStyle: 'ShortDash',
  tickColor: LINE_COLOR_DARK,
  tickPosition: 'inside',
  tickLength: 5,
  labels: {
    style: {
      color: TEXT_COLOR
    }
  },
  stackLabels: {
    style: {
      color: TEXT_COLOR
    }
  },
  title: {
    text: null,
    style: {
      color: TEXT_COLOR
    }
  }
};
export const xAxis = {
  lineColor: LINE_COLOR_DARK,
  lineWidth: 1,
  gridLineColor: LINE_COLOR,
  tickColor: LINE_COLOR_DARK,
  tickPosition: 'inside',
  tickLength: 5,
  labels: {
    style: {
      color: TEXT_COLOR
    }
  },
  title: {
    text: null,
    style: {
      color: TEXT_COLOR,
      fontWeight: '600'
    }
  }
};